import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WorkplaceService } from '@qaroni-app/workplace/services/workplace.service';
import { Workplace } from '@qaroni-app/workplace/types/workplace';
import { WorkplaceAddDialogData } from '@qaroni-app/workplace/types/workplace-add-dialog-data';
import { TimezoneService } from '@qaroni-core/services/app/timezone/timezone.service';
import { WorkplaceAddForm } from './workplace-add.form';

@Component({
  selector: 'qaroni-workplace-add-dialog',
  templateUrl: './workplace-add-dialog.component.html',
  styleUrl: './workplace-add-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkplaceAddDialogComponent
  extends WorkplaceAddForm
  implements OnInit
{
  private timezoneService = inject(TimezoneService);
  private workplaceService = inject(WorkplaceService);
  private data = inject<WorkplaceAddDialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<WorkplaceAddDialogComponent>);
  private _cdr = inject(ChangeDetectorRef);

  private workplace$ = this.workplaceService.get$();
  public timezones$ = this.timezoneService.getTimezones$();

  ngOnInit(): void {
    this.subs.add(this.workplace$.subscribe(this.getWorkplace));
    this.subs.add(this.timezones$.subscribe());
    this.timezoneService.getAllTimezones();
  }

  get hasCompanyID(): boolean {
    return !!this.data.companyID;
  }

  get companyID(): number {
    return this.data.companyID;
  }

  public onSubmit(): void {
    if (this.validatedForm && this.hasCompanyID) {
      this.enableLoading();

      this.workplaceService.create(+this.companyID, this.form.value);
    }
  }

  private getWorkplace = (workplace: Workplace): void => {
    this.disableLoading();
    this._cdr.markForCheck();

    if (!workplace) {
      return;
    }

    this.dialogRef.close(true);
  };
}
